import type { UseOrderTicketControllerReturn } from "../OrderTicket.controller";
import { useOptionOrderTicketController } from "./OptionOrderTicket.controller";
import { OptionOrderTicketPresentation } from "./OptionOrderTicket.pres";

export interface OptionOrderTicketConnectorProps
  extends Pick<
    UseOrderTicketControllerReturn,
    | "product"
    | "account"
    | "margin"
    | "quote"
    | "contract"
    | "clock"
    | "positions"
  > {
  symbol: string;
  refetchQuote: () => void;
  price?: number;
  quoteSide?: string;
  onCancel?: () => void;
  AssetSearch: JSX.Element;
  fill?: boolean;
  initialQuantity?: number;
}

export const OptionOrderTicketConnector = ({
  clock,
  product,
  account,
  margin,
  symbol,
  quote,
  contract,
  refetchQuote,
  price,
  quoteSide,
  onCancel,
  positions,
  AssetSearch,
  fill,
  initialQuantity,
}: OptionOrderTicketConnectorProps) => {
  const controllerProps = useOptionOrderTicketController({
    account,
    product,
    contract,
    quote,
    margin,
    symbol,
    price,
    quoteSide,
    onClearSelection: onCancel,
    positions,
    clock,
    initialQuantity,
  });

  return (
    <OptionOrderTicketPresentation
      onRefreshQuoteClicked={refetchQuote}
      AssetSearch={AssetSearch}
      fill={fill}
      {...controllerProps}
    />
  );
};
